import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    localStorage.removeItem("pf_token"); // legacy token cleanup — session now lives in an httpOnly cookie
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const onAuth = (data) => {
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.debug("Logout request failed", err); }
    setUser(false);
  };

  const refreshUser = () => api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {});

  return (
    <AuthContext.Provider value={{ user, ready, onAuth, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
